import { html, View } from 'rune-ts';
import klass from './Section.module.scss';
import { shareFont } from '@services/MarppleShop/shared/typography';
import { createCreatorProductStore } from '@services/MarppleShopStudio/widget/CreatorProduct/core/store/createStore.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';

interface BaseSectionData<T extends MODE = MODE> {
  store: ReturnType<typeof createCreatorProductStore<T>>;
}

export abstract class BaseSection<
  T extends MODE,
  TData extends BaseSectionData<T> = BaseSectionData<T>,
> extends View<TData> {
  protected abstract readonly sectionTitle: string;
  public abstract inputViews(): Array<View>;

  override template() {
    return html`
      <div class="${klass.section_root}">
        <div class="${shareFont('20_bold', '16_bold')}">${this.sectionTitle}</div>
        ${this.inputViews()}
      </div>
    `;
  }
}
